var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid person", class: "person--" + _vm.type },
    [
      _c("div", { staticClass: "grid__col--1 h-no-padding h-center-align" }, [
        _vm.icon
          ? _c("span", {
              staticClass: "glyphicon queue-detail__glyph",
              class: _vm.iconClass,
              attrs: { "aria-hidden": "true" }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col--11 h-no-margin h-no-padding" }, [
        _vm._v(_vm._s(_vm.person.name))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }